<template>
  <div class="check-work-body">
    <div>
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
      </div>

      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="name" label="角色名称" align="center" width="240"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="180">
            <template slot-scope="scope">
              {{scope.row.status?'显示':'隐藏'}}
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="创建时间" align="center" width="180"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" align="center" width="180"></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCmsChannel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" top="10vh" width="600px">

      <div style="max-height: 530px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="角色名称" prop="title">
            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="角色用户" prop="title">
            <el-select v-model="form.user_ids" multiple filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="getUserList" :loading="getUserLoading" style="width: 400px">
              <el-option v-for="item in userList" :key="item.id" :label="item.name + ' - ' + item.department_name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管理项目" prop="title">
            <el-select v-model="form.project_ids" multiple filterable placeholder="请输入关键词" style="width: 400px">
              <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="title">
            <el-radio v-model="form.status" :label="1">显示</el-radio>
            <el-radio v-model="form.status" :label="0">隐藏</el-radio>
          </el-form-item>
          <el-form-item label="页面权限" prop="title">
            <div class="tree-wrap">
              <el-tree ref="tree" node-key="id" :data="menuList" :default-checked-keys="form.menu_ids" show-checkbox @check-change="handleCheckChange"></el-tree>
            </div>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Http from "./common/Http";
import UploadFilesSysc from "./components/UploadFilesSysc";
import UploadFileSysc from "./components/UploadFileSysc";

export default {
  name:"UserRole",
  components: {UploadFileSysc, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        user_ids: [],
        project_ids: [],
        menu_ids: [],
        status:"",
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      error_list:[],
      error_show_status:false,

      getUserLoading: false,
      userList: [],

      projectList: [],
      menuList: [],

    }
  },
  created() {
    this.host_url=Http.getBaseURL();
    this.uploadUrl=this.host_url+"flow/UserRole/uploadFile";
    // this.getList()
  },
  activated() {
    this.getList()
    this.getProjectList()
    this.getMenuList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        channel_id:"",
        title:"",
        description:"",
        content:"",
        image:"",
        link:"",
        sort:"",
        views:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      Http.get("flow/UserRole/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {
      this.dialogVisible = true
      this.userList = []
      if(!item) {
        this.form = this.getFormData({})
      } else {
        let data = this.getFormData(item)
        data.project_ids = typeof data.project_ids == 'string' && data.project_ids ? data.project_ids.split(',').map(val => Number(val)) : []
        data.user_ids = typeof data.user_ids == 'string' && data.user_ids ? data.user_ids.split(',').map(val => Number(val)) : []
        data.menu_ids = typeof data.menu_ids == 'string' && data.menu_ids ? data.menu_ids.split(',') : [],
        this.form = data

        if(this.$refs.tree) this.$refs.tree.setCheckedKeys(data.menu_ids)

        if(data.user_ids.length) this.getUserListByIds(data.user_ids.join(','), res => {})
      }

    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          data.user_ids = data.user_ids.join(',')
          data.project_ids = data.project_ids.join(',')
          data.menu_ids = data.menu_ids.join(',')
          Http.post("flow/UserRole/saveUserRole",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      Http.post("flow/UserRole/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    deleteCmsChannel(item){
      var that=this;
      Http.post("flow/UserRole/deleteUserRole", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    getUserList(query) {
      if (query !== '') {
        this.getUserLoading = true
        Http.post("hr/user/getUserList", {keyword: query, page: 1, page_size: 100}, res => {
          this.getUserLoading = false
          if(res.code == 0) {
            this.userList = res.data
          } else {
            this.userList = []
          }
        })

      } else {
        this.userList = [];
      }
    },
    getUserListByIds(ids, callback) {

      Http.post("hr/user/getUserList", {ids: ids, page: 1, page_size: 100}, res => {
        this.getUserLoading = false
        if(res.code == 0) {
          this.userList = res.data
        } else {
          this.userList = []
        }
        callback()
      })

    },

    getProjectList() {
      this.$myhttp.get("api/Project/getProjectList", {params: {page_size: 999}}).then(resp => {
        let res = resp.data
        if(res.code == 0) {
          this.projectList = res.data
        } else {
          this.projectList = []
        }
      })
    },

    getMenuList(data) {

      this.$myhttp.get("admin/getMenuAllTree").then(resp => {
        let res = resp.data
        this.menuList = res.data
      })

    },

    handleCheckChange(data) {
      let nodes = this.$refs.tree.getCheckedNodes()
      this.form.menu_ids = nodes.map(item => item.id)
    }

  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}

.tree-wrap {
  width: 400px;
  height: 320px;
  border-radius: 5px;
  border: 1px solid #e5e5e5;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/UserRole.vue